import React from 'react'
import PropTypes from 'prop-types';

const Address = ({ address }) => {
  return (
    <address>
      { address.map((part, index) => <p key={`part-${index}`}>{ part }</p>) }
    </address>
  );
};

Address.propTypes = {
  address: PropTypes.array.isRequired,
};

export default Address;



// WEBPACK FOOTER //
// ./src/components/Address.js